import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/database';
import _ from 'lodash'
import format from 'date-fns/format'
import addDays from 'date-fns/add_days';
import { getUsersByCompany } from './cacheService'
export default {
  namespaced: true,
  state: {
    // membersall: [],
    memberKey: [],
    teamHeight: '',
    teamkeys: [],
    datalist: [],
    datalistAll: [],
    datalistSearchAll: [],
    teamList: [],
    teamSelected: "all",
    statusSelected: "all",
    waitTypingSearchBox: false,
    loadingManager: false,
    loadingCoaching: true,
    insightsOpenRateSetting: {
      active: 60,
      passive: 20
    },
    feedbackReplyRateSetting: {
      active: 40,
      passive: 10
    },
    size_page: 10,
    inputSearchManager: "",
    managerResults: 0,
    managerPage: 1,
    managerSortField: "",
    managerSortOrder: "",
    managerTypingStatus: null,
    activeOverview: [],
    insightToday: [],
    criticalAllTeam: [],
    directReportByKey: [],
    showSnackbar: false,
    dataexportall: [],
    modalCoachingData: []
  },
  mutations: {
    setTeamHeight(state: any, value: any) {
      state.teamHeight = value
    },
    setMemberKey(state: any, result: any) {
      state.memberKey = result
    },
    
    setDataList(state: any, result: any) {
      state.datalist = result || [];
    },
    setDataListAll(state: any, result: any) {
      state.datalistAll = result || [];
    },
    setDataListSearchAll(state: any, result: any) {
      state.datalistSearchAll = result || [];
    },
    setTeamList(state: any, result: any) {
      state.teamList = result || [];
    },
    setTeamSelected(state: any, value: any) {
      state.teamSelected = value || "all";
    },
    setStatusSelected(state: any, value: any) {
      state.statusSelected = value || "all";
    },
    setInputSearchManager(state: any, text: any) {
      state.inputSearchManager = text || "";
    },
    setWaitTypingSearchBox(state: any, status: any) {
      state.waitTypingSearchBox = status || false;
    },
    setInsightsOpenRateSetting(state: any, setting: any) {
      if (setting.active && setting.passive) {
        state.insightsOpenRateSetting = setting;
      }
    },
    setFeedbackReplyRateSetting(state: any, setting: any) {
      if (setting.active && setting.passive) {
        state.feedbackReplyRateSetting = setting;
      }
    },
    loadingManager(state: any, status: any) {
      state.loadingManager = status;
    },
    loadingCoaching(state: any, status: any) {
      state.loadingCoaching = status;
    },
    setManagerResults(state: any, result: any) {
      state.managerResults = result
    },
    setManagerPage(state: any, result: any) {
      state.managerPage = result
    },
    setManagerSortField(state: any, result: any) {
      state.managerSortField = result
    },
    setManagerSortOrder(state: any, result: any) {
      state.managerSortOrder = result
    },
    setManagerTypingStatus(state: any, status: any) {
      state.managerTypingStatus = status
    },
    setActiveOverview(state: any, result: any) {
      state.activeOverview = result
    },
    setInsightToday(state: any, result: any) {
      state.insightToday = result
    },
    setCriticalAllTeam(state: any, result: any) {
      state.criticalAllTeam = result
    },
    setDirectReportByKey(state: any, result: any) {
      state.directReportByKey = result
    },
    setSnackbar(state: any, value: any) {
      state.showSnackbar = value
    },
    setDataExportAll(state: any, value: any) {
      state.dataexportall = value
    },
    setModalCoachingData(state: any, value: any) {
      state.modalCoachingData = value
    },
  },
  actions: {
    resetState({ commit }: any) {
      const data: Array<any> = [];
      data['user'] = new Array()
      data['user'].firstname = ''
      data['user'].lastname = ''
      data['user'].team_name = ''
      data['coaching'] = new Array()
      commit('setModalCoachingData', data)
    },
    async getDataAll({ commit, dispatch, rootState, state }: any, selectTeam: any) {
      commit('loadingManager', true);
      const allUser = await getUsersByCompany(rootState.authen.user.company)
      // const allTeam = (await firebase.database().ref('team').orderByChild("company").equalTo(`${rootState.authen.user.company}`).once('value')).val()
      
      if (rootState.team.teamsfixedall.length > 0) {
        _.forEach(rootState.team.teamsall, (value) => {
          state.teamkeys[value.key] = value
        });
      } else {
        const team2 = (await firebase.database().ref('team').orderByChild("company").equalTo(`${rootState.authen.user.company}`).once('value')).val()
        _.forEach(team2, (value, key) => {
          state.teamkeys[key] = value
        });
      }
      if (!selectTeam) {
        if (!state.teamHeight) {
          if (rootState.team.teamsfixedall.length > 0) {
            _.forEach(rootState.team.teamsfixedall, (value) => {
              if (value.parent == '') {
                selectTeam = value.key
                return false
              }
            });
            commit('setTeamHeight', selectTeam)
          } else {
            await firebase.database().ref('team').orderByChild('company').equalTo(`${rootState.authen.user.company}`).once('value', snapshot => {
              snapshot.forEach((doc): any => {
                if (!doc.val().parent) {
                  selectTeam = doc.key
                }
              });
            });
            commit('setTeamHeight', selectTeam)
          }
        } else {
          selectTeam = state.teamHeight
        }
      }
      firebase.database().ref().child('team').orderByChild('company').equalTo(`${rootState.authen.user.company}`).once('value', snapshot => {
        let allTeam:any
        allTeam = {}
        const teams:Array<any> = [];
        const teams_temp:Array<any> = [];
        let chk_teams_master:Array<any> = [];
        const parent:{ [key: string]: string} = {};
        snapshot.forEach((doc):any => {
            const team = doc.val()
            team.key = doc.key
            team.key_temp = doc.key
            team.value = doc.val().name
            teams.push(team)
            teams_temp[team.key] = team
            allTeam[team.key] = team
            if(doc.key) parent[doc.key] = doc.val().name
        });
        _.forEach(teams, (value,key)=> {
            if(value.parent){
              teams[key].parent_name = parent[value.parent]
              teams_temp[value.key].parent_name = parent[value.parent]
            }else{
              teams[key].parent_name = '';
              teams_temp[value.key].parent_name = '';
              if(chk_teams_master['count'] == undefined){
                  chk_teams_master['count'] = 1
              }else{
                  chk_teams_master['count'] += 1
              }
              if(chk_teams_master['team'] == undefined){
                  chk_teams_master['team'] = new Array()
              }
              chk_teams_master['team'].push(value.key)
            }
        });
        if(chk_teams_master['count'] == 1){
          let chkUser = _.filter(allUser, { 'team': chk_teams_master['team'][0] });
          if(chkUser.length > 0){
          }else{
            let chkTeam:any = _.filter(allTeam, { 'parent': chk_teams_master['team'][0] });
            if(chkTeam && chkTeam.length > 0){
              const chkTeamNextLevel:Array<any> = [];
              let chkCount = 0
              _.forEach(chkTeam, (value, key) => {
                  chkTeamNextLevel.push(value.key)
              });
              if(chkTeamNextLevel.length == 1){
                  for(const x in teams_temp){
                      if(chk_teams_master['team'][0] == teams_temp[x].key){
                          selectTeam = chkTeamNextLevel[0]
                      }
                  }
              } else {
                  const chkUserInTeam:Array<any> = [];
                  _.forEach(chkTeamNextLevel, (value, key) => {
                      let chkUser = _.filter(allUser, { team: value });
                      if(chkUser.length > 0){
                          chkUserInTeam.push(value)
                          chkCount++
                      }
                  });
                  if(chkCount == 1){
                      for(const x in teams_temp){
                          if(chk_teams_master['team'][0] == teams_temp[x].key){
                              selectTeam = chkUserInTeam[0]
                          }
                      }
                  }
              }
            }
          }
        }else{

        }
      });
      // commit('setTeamSelected', selectTeam)
      if (state.datalistAll.length == 0) {
        const users: Array<any> = [];
        const userSub:Array<any> = [];
        const _usersByCompany = await getUsersByCompany(`${rootState.authen.user.company}`)
        Object.entries(_usersByCompany).forEach(([childKey, childData]:any) => {
            const u = childData
            u.key = childKey
            if(u.profilepic_small){
              u.profilepic = u.profilepic_small;
            }else if (u.profilepic_crop){
              u.profilepic = u.profilepic_crop;
            }else if (u.profilepic){
              u.profilepic = u.profilepic;
            }else {
              u.profilepic = "";
            }
            u.fullname = u.firstname + ' ' + u.lastname
            u.shortname = u.firstname.charAt(0) + u.lastname.charAt(0)
            if(u.team) u.team_name = (state.teamkeys[u.team]!=undefined)?state.teamkeys[u.team]["name"]:''
            // users.push(u)
            if(u.boss){
              if(userSub[u.boss] === undefined){
                userSub[u.boss] = new Array()
              }
              userSub[u.boss].push(u)
            }
            users[u.email] = u
          });
        commit('setMemberKey', users);
        commit('setDirectReportByKey',userSub)
        dispatch('getDataTable', selectTeam)
      }else{
        dispatch('getDataTable', selectTeam)
      }
    },
    async getDataTable({ commit, dispatch, rootState, state }: any, selectTeam: any) {
      const company = (await firebase.database().ref(`company/${rootState.authen.user.company}`).once('value')).val()
      let act_open_rate = company.manager_classification ? company.manager_classification.active_open_rate : state.insightsOpenRateSetting.active
      let act_feedback_rate = company.manager_classification ? company.manager_classification.active_feedback_rate : state.feedbackReplyRateSetting.active
      let pass_open_rate = company.manager_classification ? company.manager_classification.passive_open_rate : state.insightsOpenRateSetting.passive
      let pass_feedback_rate = company.manager_classification ? company.manager_classification.passive_feedback_rate : state.feedbackReplyRateSetting.passive
      let listData: Array<any> = []
      let countAll = 0
      let countAct = 0
      let countPas = 0
      let countInact = 0
      const insightTeams: any = [];
      const criticalTeams: any = [];
      let teamOneLevel: any = [];
      await firebase.firestore().collection('organization1level').doc(`${rootState.authen.user.company}-${selectTeam}`).get()
      .then(function (doc) {
        teamOneLevel = doc.data()
      });
      var promise1 = new Promise(function(resolve, reject) {
        if(state.criticalAllTeam && Object.keys(state.criticalAllTeam).length > 0){
          resolve(state.criticalAllTeam);
        }else{
          firebase.firestore().collection('report_weekly_manager_direct_all').where('company', '==', rootState.authen.user.company).where('date', '>', format(addDays(new Date(), -30), 'YYYY-MM-DD')).orderBy('date').get().then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
              if (insightTeams[doc.data().quest_id + '==' + doc.data().email] === undefined) {
                insightTeams[doc.data().quest_id + '==' + doc.data().email] = [];
              }
              insightTeams[doc.data().quest_id + '==' + doc.data().email].push(doc.data());
            });
            const color = ['red', 'yellow'];
            for (const x in insightTeams) {
              const questions = x.split('==');
              if (questions[0] === '-L1QWPtZvax_KlJgpNxF' && insightTeams[x].length > 1) {//feedback
                const lastweek = insightTeams[x][insightTeams[x].length - 2];
                const thisweek = insightTeams[x][insightTeams[x].length - 1];
                if (color.includes(lastweek.color) || color.includes(thisweek.color)) {
                  if (criticalTeams[questions[1]] === undefined) {
                    criticalTeams[questions[1]] = [];
                  }
                  criticalTeams[questions[1]]['Feedback'] = 'Feedback';
                }
              } else if (questions[0] === '-L1Qug-PhtzVOR2Dr5q7' && insightTeams[x].length > 1) {//real manager
                const lastweek = insightTeams[x][insightTeams[x].length - 2];
                const thisweek = insightTeams[x][insightTeams[x].length - 1];
                if (color.includes(lastweek.color) || color.includes(thisweek.color)) {
                  if (criticalTeams[questions[1]] === undefined) {
                    criticalTeams[questions[1]] = [];
                  }
                  criticalTeams[questions[1]]['Rel. Manager'] = 'Rel. Manager';
                }
              } else if (questions[0] === '-L36rxTgLhZTL4mq4SV1' && insightTeams[x].length > 1) {//wellness
                const lastweek = insightTeams[x][insightTeams[x].length - 2];
                const thisweek = insightTeams[x][insightTeams[x].length - 1];
                if (color.includes(lastweek.color) || color.includes(thisweek.color)) {
                  if (criticalTeams[questions[1]] === undefined) {
                    criticalTeams[questions[1]] = [];
                  }
                  criticalTeams[questions[1]]['Wellness'] = 'Wellness';
                }
              } else if (questions[0] === '-L0J5FFsGQYVkfcGujWo' && insightTeams[x].length > 1) {//recognition
                const lastweek = insightTeams[x][insightTeams[x].length - 2];
                const thisweek = insightTeams[x][insightTeams[x].length - 1];
                if (color.includes(lastweek.color) || color.includes(thisweek.color)) {
                  if (criticalTeams[questions[1]] === undefined) {
                    criticalTeams[questions[1]] = [];
                  }
                  criticalTeams[questions[1]]['Recognition'] = 'Recognition';
                }
              } else if (questions[0] === '-L1FmpFO-v8IZc_B5EB7') {//satisfaction
                const thisweek = insightTeams[x][insightTeams[x].length - 1];
                if (color.includes(thisweek.color)) {
                  if (criticalTeams[questions[1]] === undefined) {
                    criticalTeams[questions[1]] = [];
                  }
                  criticalTeams[questions[1]]['Satisfaction'] = 'Satisfaction';
                }
              } else if (questions[0] === '-Kgs549ClADmNQwoNbbG') {//Rel. Colleagues
                const thisweek = insightTeams[x][insightTeams[x].length - 1];
                if (color.includes(thisweek.color)) {
                  if (criticalTeams[questions[1]] === undefined) {
                    criticalTeams[questions[1]] = [];
                  }
                  criticalTeams[questions[1]]['Rel. Colleagues'] = 'Rel. Colleagues';
                }
              } else if (questions[0] === '-Kgn7oxLPPWlbM_ZDc_h') {//Personal Growth
                const thisweek = insightTeams[x][insightTeams[x].length - 1];
                if (color.includes(thisweek.color)) {
                  if (criticalTeams[questions[1]] === undefined) {
                    criticalTeams[questions[1]] = [];
                  }
                  criticalTeams[questions[1]]['Personal Growth'] = 'Personal Growth';
                }
              } else if (questions[0] === '-LtOL_iR1N-ev2b_8Tmg') {//Company Alignment
                const thisweek = insightTeams[x][insightTeams[x].length - 1];
                if (color.includes(thisweek.color)) {
                  if (criticalTeams[questions[1]] === undefined) {
                    criticalTeams[questions[1]] = [];
                  }
                  criticalTeams[questions[1]]['Company Alignment'] = 'Company Alignment';
                }
              } else if (questions[0] === '-L2ycGiBDo3rDGjLNKwW') {//Ambassadorship
                const thisweek = insightTeams[x][insightTeams[x].length - 1];
                if (color.includes(thisweek.color)) {
                  if (criticalTeams[questions[1]] === undefined) {
                    criticalTeams[questions[1]] = [];
                  }
                  criticalTeams[questions[1]]['Ambassadorship'] = 'Ambassadorship';
                }
              }
            }
            commit('setCriticalAllTeam', criticalTeams);
            resolve(criticalTeams);
          });
        }
      });
      var promise2 = new Promise(function(resolve, reject) {
        const data2:Array<any> = []
        firebase.firestore().collection('insight_manager_month').doc(`${selectTeam}`).collection('managers').where('updated', '>', format(addDays(new Date(), -30), 'YYYY-MM-DD')).get()
        .then(function (querySnapshot) {
          querySnapshot.forEach(function (doc) {
            const data = doc.data()
            if (data2[data.email] === undefined) {
              data2[data.email] = new Array()
            }
            data2[data.email].team = doc.data().team;
            data2[data.email].daily = (data.report_daily_boss) ? Math.round(data.report_daily_boss) : 0
            if (data2[data.email].daily > 100) {
              data2[data.email].daily = 100
            }
            data2[data.email].weekly = (data.report_weekly_boss) ? Math.round(data.report_weekly_boss) : 0
            if (data2[data.email].weekly > 100) {
              data2[data.email].weekly = 100
            }
            data2[data.email].feedback = (data.feedback) ? Math.round(data.feedback) : 0
            if (data2[data.email].feedback > 100) {
              data2[data.email].feedback = 100
            }
            let dailyData = (data2[data.email].daily) ? data2[data.email].daily : 0;
            let weeklyData = (data2[data.email].weekly) ? data2[data.email].weekly : 0;
            let open_rate = ((dailyData * 5 + weeklyData))/6
            data2[data.email].open_rate = open_rate
            if(open_rate >= act_open_rate && data.feedback >= act_feedback_rate){
              data2[data.email].active = 'Y'
              countAct += 1
            }else if(open_rate >= pass_open_rate && data.feedback >= pass_feedback_rate){
              data2[data.email].passive = 'Y'
              countPas += 1
            }else{
              data2[data.email].inactive = 'Y'
              countInact += 1
            }
          });
          firebase.firestore().collection('report_monthly_potential').where("company", "==", `${rootState.authen.user.company}`).get()
            .then(function (querySnapshot) {
              querySnapshot.forEach(function (doc) {
                const data = doc.data()
                if(data2[data.email]){
                  if (data2[data.email].super_feedback === undefined) {
                    data2[data.email].super_feedback = new Array()
                    data2[data.email].super_feedback.total = 0
                  }
  
                  if (data.supperfeedback) {
                    data2[data.email].super_feedback.total = Math.round((data.supperfeedback * 100) / data.answer)
                    if (data2[data.email].super_feedback.total > 100) {
                      data2[data.email].super_feedback.total = 100
                    }
                  }
                }
              });
              resolve(data2);
            });
        });
      });
      var promise3 = new Promise(function(resolve, reject) {
        const data3:Array<any> = []
        let dataThirty :Array<any> = []
        let dataSixty :Array<any> = []
        let dataAllTeamThirty :Array<any> = []
        dataAllTeamThirty['report_daily_boss'] = new Array()
        dataAllTeamThirty['report_weekly_boss'] = new Array()
        dataAllTeamThirty['feedback'] = new Array()
        dataAllTeamThirty['report_daily_boss'] = new Array()
        dataAllTeamThirty['report_weekly_boss'] = new Array()
        dataAllTeamThirty['feedback'] = new Array()

        let dataAllTeamSixty :Array<any> = []
        dataAllTeamSixty['report_daily_boss'] = new Array()
        dataAllTeamSixty['report_weekly_boss'] = new Array()
        dataAllTeamSixty['feedback'] = new Array()
        dataAllTeamSixty['report_daily_boss'] = new Array()
        dataAllTeamSixty['report_weekly_boss'] = new Array()
        dataAllTeamSixty['feedback'] = new Array()
        let sixtyDate = format(addDays(new Date(), -60), 'YYYY-MM-DD')
        let thirtyDate = format(addDays(new Date(), -30), 'YYYY-MM-DD')
        if(state.insightToday && state.insightToday.thirty){
          dataThirty = state.insightToday.thirty
          dataSixty = state.insightToday.sixty
          if(teamOneLevel){
            _.forEach(teamOneLevel.parent, (value,key)=> {
              let teamId:any = key
              let arrDataThirty:any = _.filter(dataThirty, { team: teamId });
              if(arrDataThirty.length > 0){
                _.forEach(arrDataThirty, (item,index)=> {
                  dataAllTeamThirty[item.type].read = dataAllTeamThirty[item.type].read ? dataAllTeamThirty[item.type].read + item.read : item.read
                  dataAllTeamThirty[item.type].receive = dataAllTeamThirty[item.type].receive ? dataAllTeamThirty[item.type].receive + item.receive : item.receive
                });
              }
              let arrDataSixty:any = _.filter(dataSixty, { team: teamId });
              if(arrDataSixty.length > 0){
                _.forEach(arrDataSixty, (item,index)=> {
                  dataAllTeamSixty[item.type].read = dataAllTeamSixty[item.type].read ? dataAllTeamSixty[item.type].read + item.read : item.read
                  dataAllTeamSixty[item.type].receive = dataAllTeamSixty[item.type].receive ? dataAllTeamSixty[item.type].receive + item.receive : item.receive
                });
              }
            });
          }else{
            let arrDataThirty:any = _.filter(dataThirty, { team: selectTeam });
              if(arrDataThirty.length > 0){
                _.forEach(arrDataThirty, (item,index)=> {
                  dataAllTeamThirty[item.type].read = dataAllTeamThirty[item.type].read ? dataAllTeamThirty[item.type].read + item.read : item.read
                  dataAllTeamThirty[item.type].receive = dataAllTeamThirty[item.type].receive ? dataAllTeamThirty[item.type].receive + item.receive : item.receive
                });
              }
              let arrDataSixty:any = _.filter(dataSixty, { team: selectTeam });
              if(arrDataSixty.length > 0){
                _.forEach(arrDataSixty, (item,index)=> {
                  dataAllTeamSixty[item.type].read = dataAllTeamSixty[item.type].read ? dataAllTeamSixty[item.type].read + item.read : item.read
                  dataAllTeamSixty[item.type].receive = dataAllTeamSixty[item.type].receive ? dataAllTeamSixty[item.type].receive + item.receive : item.receive
                });
              }
          }
          data3['report_daily_boss'] = {
            thirty: (isNaN(Math.round(dataAllTeamThirty['report_daily_boss'].read * 100 / dataAllTeamThirty['report_daily_boss'].receive)) ? 0 : ((Math.round(dataAllTeamThirty['report_daily_boss'].read * 100 / dataAllTeamThirty['report_daily_boss'].receive)) > 100) ? 100 : Math.round(dataAllTeamThirty['report_daily_boss'].read * 100 / dataAllTeamThirty['report_daily_boss'].receive)),
            sixty: (isNaN(Math.round(dataAllTeamSixty['report_daily_boss'].read * 100 / dataAllTeamSixty['report_daily_boss'].receive)) ? 0 : ((Math.round(dataAllTeamSixty['report_daily_boss'].read * 100 / dataAllTeamSixty['report_daily_boss'].receive)) > 100) ? 100 : Math.round(dataAllTeamSixty['report_daily_boss'].read * 100 / dataAllTeamSixty['report_daily_boss'].receive)),
          }
          data3['report_weekly_boss'] = {
            thirty: (isNaN(Math.round(dataAllTeamThirty['report_weekly_boss'].read * 100 / dataAllTeamThirty['report_weekly_boss'].receive)) ? 0 : ((Math.round(dataAllTeamThirty['report_weekly_boss'].read * 100 / dataAllTeamThirty['report_weekly_boss'].receive)) > 100) ? 100 : Math.round(dataAllTeamThirty['report_weekly_boss'].read * 100 / dataAllTeamThirty['report_weekly_boss'].receive)),
            sixty: (isNaN(Math.round(dataAllTeamSixty['report_weekly_boss'].read * 100 / dataAllTeamSixty['report_weekly_boss'].receive)) ? 0 : ((Math.round(dataAllTeamSixty['report_weekly_boss'].read * 100 / dataAllTeamSixty['report_weekly_boss'].receive)) > 100) ? 100 : Math.round(dataAllTeamSixty['report_weekly_boss'].read * 100 / dataAllTeamSixty['report_weekly_boss'].receive)),
          }
          data3['feedback'] = {
            thirty: (isNaN(Math.round(dataAllTeamThirty['feedback'].read * 100 / dataAllTeamThirty['feedback'].receive)) ? 0 : ((Math.round(dataAllTeamThirty['feedback'].read * 100 / dataAllTeamThirty['feedback'].receive)) > 100) ? 100 : Math.round(dataAllTeamThirty['feedback'].read * 100 / dataAllTeamThirty['feedback'].receive)),
            sixty: (isNaN(Math.round(dataAllTeamSixty['feedback'].read * 100 / dataAllTeamSixty['feedback'].receive)) ? 0 : ((Math.round(dataAllTeamSixty['feedback'].read * 100 / dataAllTeamSixty['feedback'].receive)) > 100) ? 100 : Math.round(dataAllTeamSixty['feedback'].read * 100 / dataAllTeamSixty['feedback'].receive)),
          }
          data3['report_daily_boss'].compare = data3['report_daily_boss'].thirty - data3['report_daily_boss'].sixty
          data3['report_weekly_boss'].compare = data3['report_weekly_boss'].thirty - data3['report_weekly_boss'].sixty
          data3['feedback'].compare = data3['feedback'].thirty - data3['feedback'].sixty
          let setResultsData :Array<any> = []
          setResultsData['thirty'] = dataThirty
          setResultsData['sixty'] = dataSixty
          commit('setInsightToday', setResultsData);
          resolve(data3);
        }else{
          firebase.firestore().collection('insight_manager_today').where('company', '==', rootState.authen.user.company).where("date", ">=", format(addDays(new Date(), -60), 'YYYY-MM-DD')).where("date", "<", format(new Date(), 'YYYY-MM-DD')).orderBy('date').get().then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
              const data = doc.data()
              if(data.date >= sixtyDate && data.date < thirtyDate){
                dataSixty.push(data)
              }else{
                dataThirty.push(data)
              }
            });
            if(teamOneLevel){
              _.forEach(teamOneLevel.parent, (value,key)=> {
                let teamId:any = key
                let arrDataThirty:any = _.filter(dataThirty, { team: teamId });
                if(arrDataThirty.length > 0){
                  _.forEach(arrDataThirty, (item,index)=> {
                    dataAllTeamThirty[item.type].read = dataAllTeamThirty[item.type].read ? dataAllTeamThirty[item.type].read + item.read : item.read
                    dataAllTeamThirty[item.type].receive = dataAllTeamThirty[item.type].receive ? dataAllTeamThirty[item.type].receive + item.receive : item.receive
                  });
                }
                let arrDataSixty:any = _.filter(dataSixty, { team: teamId });
                if(arrDataSixty.length > 0){
                  _.forEach(arrDataSixty, (item,index)=> {
                    dataAllTeamSixty[item.type].read = dataAllTeamSixty[item.type].read ? dataAllTeamSixty[item.type].read + item.read : item.read
                    dataAllTeamSixty[item.type].receive = dataAllTeamSixty[item.type].receive ? dataAllTeamSixty[item.type].receive + item.receive : item.receive
                  });
                }
              });
            }else{
              let arrDataThirty:any = _.filter(dataThirty, { team: selectTeam });
                if(arrDataThirty.length > 0){
                  _.forEach(arrDataThirty, (item,index)=> {
                    dataAllTeamThirty[item.type].read = dataAllTeamThirty[item.type].read ? dataAllTeamThirty[item.type].read + item.read : item.read
                    dataAllTeamThirty[item.type].receive = dataAllTeamThirty[item.type].receive ? dataAllTeamThirty[item.type].receive + item.receive : item.receive
                  });
                }
                let arrDataSixty:any = _.filter(dataSixty, { team: selectTeam });
                if(arrDataSixty.length > 0){
                  _.forEach(arrDataSixty, (item,index)=> {
                    dataAllTeamSixty[item.type].read = dataAllTeamSixty[item.type].read ? dataAllTeamSixty[item.type].read + item.read : item.read
                    dataAllTeamSixty[item.type].receive = dataAllTeamSixty[item.type].receive ? dataAllTeamSixty[item.type].receive + item.receive : item.receive
                  });
                }
            }
            data3['report_daily_boss'] = {
              thirty: (isNaN(Math.round(dataAllTeamThirty['report_daily_boss'].read * 100 / dataAllTeamThirty['report_daily_boss'].receive)) ? 0 : ((Math.round(dataAllTeamThirty['report_daily_boss'].read * 100 / dataAllTeamThirty['report_daily_boss'].receive)) > 100) ? 100 : Math.round(dataAllTeamThirty['report_daily_boss'].read * 100 / dataAllTeamThirty['report_daily_boss'].receive)),
              sixty: (isNaN(Math.round(dataAllTeamSixty['report_daily_boss'].read * 100 / dataAllTeamSixty['report_daily_boss'].receive)) ? 0 : ((Math.round(dataAllTeamSixty['report_daily_boss'].read * 100 / dataAllTeamSixty['report_daily_boss'].receive)) > 100) ? 100 : Math.round(dataAllTeamSixty['report_daily_boss'].read * 100 / dataAllTeamSixty['report_daily_boss'].receive)),
            }
            data3['report_weekly_boss'] = {
              thirty: (isNaN(Math.round(dataAllTeamThirty['report_weekly_boss'].read * 100 / dataAllTeamThirty['report_weekly_boss'].receive)) ? 0 : ((Math.round(dataAllTeamThirty['report_weekly_boss'].read * 100 / dataAllTeamThirty['report_weekly_boss'].receive)) > 100) ? 100 : Math.round(dataAllTeamThirty['report_weekly_boss'].read * 100 / dataAllTeamThirty['report_weekly_boss'].receive)),
              sixty: (isNaN(Math.round(dataAllTeamSixty['report_weekly_boss'].read * 100 / dataAllTeamSixty['report_weekly_boss'].receive)) ? 0 : ((Math.round(dataAllTeamSixty['report_weekly_boss'].read * 100 / dataAllTeamSixty['report_weekly_boss'].receive)) > 100) ? 100 : Math.round(dataAllTeamSixty['report_weekly_boss'].read * 100 / dataAllTeamSixty['report_weekly_boss'].receive)),
            }
            data3['feedback'] = {
              thirty: (isNaN(Math.round(dataAllTeamThirty['feedback'].read * 100 / dataAllTeamThirty['feedback'].receive)) ? 0 : ((Math.round(dataAllTeamThirty['feedback'].read * 100 / dataAllTeamThirty['feedback'].receive)) > 100) ? 100 : Math.round(dataAllTeamThirty['feedback'].read * 100 / dataAllTeamThirty['feedback'].receive)),
              sixty: (isNaN(Math.round(dataAllTeamSixty['feedback'].read * 100 / dataAllTeamSixty['feedback'].receive)) ? 0 : ((Math.round(dataAllTeamSixty['feedback'].read * 100 / dataAllTeamSixty['feedback'].receive)) > 100) ? 100 : Math.round(dataAllTeamSixty['feedback'].read * 100 / dataAllTeamSixty['feedback'].receive)),
            }
            data3['report_daily_boss'].compare = data3['report_daily_boss'].thirty - data3['report_daily_boss'].sixty
            data3['report_weekly_boss'].compare = data3['report_weekly_boss'].thirty - data3['report_weekly_boss'].sixty
            data3['feedback'].compare = data3['feedback'].thirty - data3['feedback'].sixty
            let setResultsData :Array<any> = []
            setResultsData['thirty'] = dataThirty
            setResultsData['sixty'] = dataSixty
            commit('setInsightToday', setResultsData);
            resolve(data3);
          });
        }
      });
      Promise.all([promise1, promise2, promise3]).then((values)=> {
        const data1:any = values[0]
        const objData:any = values[1]
        const data3:any = values[2]
        for(const index in objData){
          if(state.memberKey[index]){
            let item = state.memberKey[index]
            objData[index].firstname = item.firstname
            objData[index].lastname = item.lastname
            objData[index].email = item.email
            objData[index].shortname = item.shortname
            objData[index].fullname = item.fullname
            objData[index].team_id = item.team
            objData[index].team_name = item.team_name
            objData[index].talent = item.talent
            objData[index].network_type = item.network_type
            objData[index].profilepic = item.profilepic
            objData[index].directReport = state.directReportByKey[item.email] ? state.directReportByKey[item.email].length : 0
            
            countAll++

            if (data1[index]) {
              objData[index].critical_area = Object.keys(data1[index]).toString();
              objData[index].critical_count = Object.keys(data1[index]).length;
            }
            let dailyData = (objData[index].daily) ? objData[index].daily : 0;
            let weeklyData = (objData[index].weekly) ? objData[index].weekly : 0;
            let feedbackData = (objData[index].feedback) ? objData[index].feedback : 0
            let superfeedbackData = (objData[index].super_feedback) ? objData[index].super_feedback.total : 0
            let activityType = ''
            if(objData[index].active && objData[index].active == 'Y'){
              activityType = 'Active'
            }else if(objData[index].passive && objData[index].passive == 'Y'){
              activityType = 'Passive'
            }else if(objData[index].inactive && objData[index].inactive == 'Y'){
              activityType = 'Inactive'
            }
            listData.push({
              profilepic: objData[index].profilepic,
              firstname: objData[index].firstname,
              lastname: objData[index].lastname,
              email: objData[index].email,
              shortname: objData[index].shortname,
              fullname: objData[index].fullname,
              team_id: objData[index].team_id,
              team_name: objData[index].team_name,
              daily: dailyData,
              weekly: weeklyData,
              feedback: feedbackData,
              super_feedback: superfeedbackData,
              talent: objData[index].talent,
              active: (objData[index].active && objData[index].active == 'Y') ? "Y" : "N",
              passive: (objData[index].passive && objData[index].passive == 'Y') ? "Y" : "N",
              inactive: (objData[index].inactive && objData[index].inactive == 'Y') ? "Y" : "N",
              critical_area: (objData[index].critical_area) ? objData[index].critical_area : "",
              critical_count: (objData[index].critical_count) ? objData[index].critical_count : "",
              network_type: (objData[index].network_type) ? objData[index].network_type : "",
              directReport: (objData[index].directReport) ? objData[index].directReport : 0,
              x: feedbackData,
              y: objData[index].open_rate,
              activity_type: activityType,
            });
          }
        }
        
        listData = _.orderBy(listData, ['daily','fullname'], ['desc','asc']);
        const overViewData: Array<any> = []
        overViewData['all'] = countAll
        overViewData['active'] = countAct
        overViewData['passive'] = countPas
        overViewData['inactive'] = countInact
        overViewData['insight'] = data3
        commit('setInsightsOpenRateSetting', {
          active: act_open_rate,
          passive: pass_open_rate
        });
        commit('setFeedbackReplyRateSetting', {
          active: act_feedback_rate,
          passive: pass_feedback_rate
        });
        commit('setActiveOverview', overViewData);
        let results: Array<any> = [];
        results = listData
        
        if (state.statusSelected !== "all") {
          if(state.statusSelected == 'active'){
            results = _.filter(results, (item): any => {
              if (item.active && item.active.match("Y")) {
                return true
              }
            });
          }else if(state.statusSelected == 'passive'){
            results = _.filter(results, (item): any => {
              if (item.passive && item.passive.match("Y")) {
                return true
              }
            });
          }else if(state.statusSelected == 'inactive'){
            results = _.filter(results, (item): any => {
              if (item.inactive && item.inactive.match("Y")) {
                return true
              }
            });
          }
        }
        commit('setDataList', results.slice(0, state.size_page));
        commit('setDataListAll', listData);
        commit('setDataListSearchAll', results);
        commit("setManagerResults", results.length);
        commit('loadingManager', false)
    });
    },
    currentManagerChange({ commit, state }: any, page: any) {
      let size = state.size_page
      let start_row = (page - 1) * size
      let end_row = ((page - 1) * size) + size
      let results: Array<any> = [];
      if (state.inputSearchManager.length > 2) {
        let re = new RegExp(state.inputSearchManager, 'gi')
        let response = _.filter(state.datalistAll, (item): any => {
          if (item.fullname.match(re)) {
            return true
          } else if (item.firstname != undefined && item.firstname.match(re)) {
            return true
          } else if (item.lastname != undefined && item.lastname.match(re)) {
            return true
          }
        });
        results = response
      } else {
        results = state.datalistAll
      }
      let field = state.managerSortField
      let order = state.managerSortOrder
      
      if (order === "ascending") {
        order = 'asc'
      } else {
        order = 'desc'
      }
      if (field === "") {
        field = "daily"
      }
      results = _.orderBy(results, [field,'fullname'], [order,'asc']);
      commit('setManagerPage', page)
      commit('setDataList', results.slice(start_row, end_row))
    },
    searchManager({ commit, state, dispatch }: any, data: any) {
      clearTimeout(state.managerTypingStatus)
      state.managerTypingStatus = setTimeout(() => {
        commit('setManagerPage', 1)
          dispatch('sortManager', {
            0: state.managerSortField,
            1: state.managerSortOrder,
            3: data.value
          })
      }, data.typingTimeout)
    },
    sortManager({ commit, state }: any, value: any) {
      let results: Array<any> = [];
      results = state.datalistAll
      if (state.statusSelected !== "all") {
        if(state.statusSelected == 'active'){
          results = _.filter(results, (item): any => {
            if (item.active && item.active.match("Y")) {
              return true
            }
          });
        }else if(state.statusSelected == 'passive'){
          results = _.filter(results, (item): any => {
            if (item.passive && item.passive.match("Y")) {
              return true
            }
          });
        }else if(state.statusSelected == 'inactive'){
          results = _.filter(results, (item): any => {
            if (item.inactive && item.inactive.match("Y")) {
              return true
            }
          });
        }
      }
      let textSearching = value[3] || state.inputSearchManager;
      if (textSearching.length > 0) {
        if (results.length > 0) {
          let re = new RegExp(textSearching, 'gi')
          let response = _.filter(results, (item): any => {
            if (item.fullname.match(re)) {
              return true
            } else if (item.firstname != undefined && item.firstname.match(re)) {
              return true
            } else if (item.lastname != undefined && item.lastname.match(re)) {
              return true
            }
          });
          results = response
        }
      }

      let field = value[0]
      commit('setManagerSortField', field)
      let order = value[1]
      commit('setManagerSortOrder', order)
      
      if (order === "ascending") {
        order = 'asc'
      } else {
        order = 'desc'
      }
      if (field === "") {
        field = "daily"
      }
      let _users
      _users = _.orderBy(results, [field,'fullname'], [order,'asc']);
      commit('setManagerResults', _users.length)
      commit('setDataList', _users.slice(0, state.size_page))
      commit('setDataListSearchAll', _users)
    },
    setManagerClassificationSettings({ dispatch, commit, rootState, state }: any, setting) {
      firebase.database().ref(`/company/${rootState.authen.user.company}`).update({
        "manager_classification":{
          active_open_rate: Number(setting.insightActiveLower),
          passive_open_rate: Number(setting.insightPassiveUpper),
          active_feedback_rate: Number(setting.feedbackActiveLower),
          passive_feedback_rate: Number(setting.feedbackPassiveUpper),
        },
        updated:format(new Date(), 'YYYY-MM-DD HH:mm')
      })
      commit('setInsightsOpenRateSetting', {
        active: Number(setting.insightActiveLower),
        passive: Number(setting.insightPassiveUpper)
      });
      commit('setFeedbackReplyRateSetting', {
        active: Number(setting.feedbackActiveLower),
        passive: Number(setting.feedbackPassiveUpper)
      });
      dispatch('getDataAll', state.teamHeight)
    },
    setTeamSorting({ commit }: any, selectTeam) {
      commit('setTeamSelected', selectTeam);
    },
    setStatusSorting({ commit, dispatch, state }: any, selectStatus) {
      commit('setStatusSelected', selectStatus);
      dispatch('reponseSearchAll', selectStatus).then((result) => {
        commit('setDataList', result[0])
        commit('setDataListSearchAll', result[1])
        commit('setManagerResults', result[2])
        
      });
    },
    async reponseSearchAll({ state }: any, status: any) {
      const data: Array<any> = []
      let listData = state.datalistAll
      if (status !== "all") {
        if(status == 'active'){
          listData = _.filter(listData, (item): any => {
            if (item.active && item.active.match("Y")) {
              return true
            }
          });
        }else if(status == 'passive'){
          listData = _.filter(listData, (item): any => {
            if (item.passive && item.passive.match("Y")) {
              return true
            }
          });
        }else if(status == 'inactive'){
          listData = _.filter(listData, (item): any => {
            if (item.inactive && item.inactive.match("Y")) {
              return true
            }
          });
        }
      }
      let field = state.managerSortField
      let order = state.managerSortOrder
      
      if (order === "ascending") {
        order = 'asc'
      } else {
        order = 'desc'
      }
      if (field === "") {
        field = "daily"
      }
      listData = _.orderBy(listData, [field,'fullname'], [order,'asc']);
      data.push(listData.slice(0, state.size_page))
      data.push(listData)
      data.push(listData.length)
      return data
    },
    setSearchingText({ commit }: any, input) {
      commit('setInputSearchManager', input);
      commit('setWaitTypingSearchBox', true);
      setTimeout(() => {
        commit('setWaitTypingSearchBox', false);
      }, 500)
    },
    async getDataExport({ commit, dispatch, rootState, state }: any) {
      commit('setSnackbar', true)
      const data: Array<any> = []
      let listData = state.datalistAll

      if (state.statusSelected !== "all") {
        if(state.statusSelected == 'active'){
          listData = _.filter(listData, (item): any => {
            if (item.active && item.active.match("Y")) {
              return true
            }
          });
        }else if(state.statusSelected == 'passive'){
          listData = _.filter(listData, (item): any => {
            if (item.passive && item.passive.match("Y")) {
              return true
            }
          });
        }else if(state.statusSelected == 'inactive'){
          listData = _.filter(listData, (item): any => {
            if (item.inactive && item.inactive.match("Y")) {
              return true
            }
          });
        }
      }
      let field = state.managerSortField
      let order = state.managerSortOrder
      
      if (order === "ascending") {
        order = 'asc'
      } else {
        order = 'desc'
      }
      if (field === "") {
        field = "daily"
      }
      listData = _.orderBy(listData, [field,'fullname'], [order,'asc']);
      commit('setDataExportAll', listData)
      dispatch('genDataExport')
    },
    async genDataExport({ commit, state, dispatch, rootState }: any) {
      const dataexportall = state.dataexportall
      // Lazy chunk: exceljs is ~1 MB parsed and only needed when exporting.
      // .default || m guards webpack 4's missing CJS default interop.
      const Excel = await import(/* webpackChunkName: "exceljs" */ 'exceljs').then((m: any) => m.default || m);
      var wb = new Excel.Workbook();
      var ws = wb.addWorksheet('mySheet');
      /*TITLE*/
      ws.mergeCells('B2', 'E2');
      ws.getRow(2).height = 25
      ws.getCell('B2').font = { name: 'Arial', size: 18, bold: true }
      ws.getCell('B2').alignment = { vertical: 'middle' }

      ws.getCell('B2').value = 'Insights Manager'
      // /*Column headers*/
      ws.getColumn('A').width = 5;
      let header:any = ['','First Name','Last Name','Team Name','Email','Daily','Weekly','Reply','Super','Talent Type','Network Type','Critical Areas','Activity Types']
      ws.getRow(4).values = header

      /*Data*/
      _.forEach(dataexportall, (item, key)=> {
        let _tmp:any = [
          '',
          item.firstname,
          item.lastname,
          item.team_name,
          item.email,
          item.daily+'%',
          item.weekly+'%',
          item.feedback+'%',
          item.super_feedback+'%',
          item.talent,
          item.network_type,
          item.critical_area,
          item.activity_type
        ]
        ws.addRow(_tmp)
    });

      ws.eachRow(function (row) {
        if(row.number == 4){
          row.eachCell(function (cell) {
            ws.getCell(cell.address).font = { name: 'Arial', size: 11, bold: true }
          });
        }
        // else if(row.number > 4 ){
          // row.eachCell(function (cell) {
          //   if(cell.col == 2){
          //     ws.getCell(cell.address).font = { name: 'Arial', size: 11 }
          //   }else if(cell.col == 3){
          //     ws.getCell(cell.address).font = { name: 'Arial', size: 10 }
          //   }else if(cell.col > 3){
          //     ws.getCell(cell.address).font = { name: 'Arial', size: 10 }
          //     ws.getCell(cell.address).alignment = { horizontal: 'right' };
          //   }
          // });
        // }
      });

      wb.xlsx.writeBuffer( {
        base64: true
      })
      .then( function (xls64) {
          // build anchor tag and attach file (works in chrome)
          var a = document.createElement("a");
          var data = new Blob([xls64], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });

          var url = URL.createObjectURL(data);
          a.href = url;
          a.download = 'Insights Manager' + ".xlsx";
          document.body.appendChild(a);
          a.click();
          setTimeout(function() {
              commit('setSnackbar', false)
                  document.body.removeChild(a);
                  window.URL.revokeObjectURL(url);
              },
              0);
      })
      .catch(function(error) {
          console.log(error.message);
      });
    },
    getDataCoaching({ commit, dispatch, rootState, state }: any, email: any) {
      commit('loadingCoaching', true);
      let modalData: Array<any> = []
      modalData['user'] = new Array()
      modalData['user'].firstname = state.memberKey[email].firstname
      modalData['user'].lastname = state.memberKey[email].lastname
      modalData['user'].team_name = state.memberKey[email].team_name
      modalData['coaching'] = new Array()
      firebase.firestore().collection('coaching').where("email", "==", `${email}`).orderBy('datetime','desc').get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            const data = doc.data();
            const _temp = {};
            _temp['date'] = format(data.date, "MMMM D, YYYY")
            _temp['challenges'] = "Boost "+data.quest_type
            if(data.standard){
              _temp['standard'] = data.standard
            }else{
              // set standard for old data
              if(data.quest_type == 'Recognition'){
                _temp['standard'] = [75,50,50]
              }else if(data.quest_type == 'Personal Growth'){
                if(data.quest_follow_id && data.quest_follow_id == '-L0J42xtbRWVbsHdFWWR'){
                  _temp['standard'] = [70,40,40]
                }else{
                  _temp['standard'] = [80,50,50]
                }
              }else if(data.quest_type == 'Feedback'){
                _temp['standard'] = [80,60,60]
              }
            }
            if(data.status == 'open'){
              _temp['score'] = data.previous
              _temp['status'] = 'Pending'
            }else if(data.status == 'accept'){
              _temp['score'] = data.previous
              _temp['status'] = 'Active'
            }else if(data.status == 'congrat'){
              _temp['score'] = data.goal ? data.goal : data.previous
              _temp['status'] = 'Completed'
            }else if(data.status == 'tryagain'){
              _temp['score'] = data.notgoal ? data.notgoal : data.previous
              _temp['status'] = 'Try Again'
            }else if(data.status == 'close'){
              _temp['score'] = data.previous
              _temp['status'] = 'Close'
            }
            _temp['score'] = Math.round(Number(_temp['score'])) > 100 ? 100 : Math.round(Number(_temp['score']))
            modalData['coaching'].push(_temp)
          });
          commit('loadingCoaching', false);
          commit('setModalCoachingData', modalData)
        });
    },
  },
  getters: {
    datalistAll: ({ datalistAll }) => {
      return datalistAll
    },
    datalistSearchAll: ({ datalistSearchAll }) => {
      return datalistSearchAll
    },
    datalist: ({ datalist }) => {
      return datalist
    },
    inputSearchManager: ({ inputSearchManager }) => {
      return inputSearchManager
    },
    managerResults: ({ managerResults }) => {
      return managerResults
    },
    activeOverview: ({ activeOverview }) => {
      return activeOverview
    },
    teamList: (state: any) => {
      return state.teamList;
    },
    loadingManager: (state: any) => {
      return state.loadingManager;
    },
    loadingCoaching: (state: any) => {
      return state.loadingCoaching;
    },
    modalCoachingData: (state: any) => {
      return state.modalCoachingData;
    },
    getInsightsOpenRateSetting: (state: any) => {
      return state.insightsOpenRateSetting;
    },
    getFeedbackReplyRateSetting: (state: any) => {
      return state.feedbackReplyRateSetting;
    },
  }
}